import * as tslib_1 from "tslib";
import { timer as observableTimer } from 'rxjs';
import { take, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FichaService } from '../../ficha-veiculo.service';
import { LoginStorage } from './../../../login/login.storage';
import { ModalLoaderComponent } from './../../../shared/modais/modal-loader/modal-loader.component';
import { ModalMessageComponent } from './../../../shared/modais/modal-message/modal-message.component';
import { FichaTimelineSharedService } from './../ficha-timeline.shared.service';
import { AvalistaComponent } from './avalista/avalista.component';
import { DocumentosComponent } from './documentos/documentos.component';
import { ObservacaoComponent } from './observacao/observacao.component';
export class FichaTimelineSosComponent {
    constructor(fichaService, loginStorage, sharedService, router) {
        this.fichaService = fichaService;
        this.loginStorage = loginStorage;
        this.sharedService = sharedService;
        this.router = router;
        this.isSos = false;
    }
    sendSos() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!moment(this.dataLimiteAtendimento).isBefore(moment())) {
                if (!this.validaEnvioSOS()) {
                    return;
                }
                if (this.hasObservacao()) {
                    yield this.observacao.sendObservacao();
                }
                if (this.hasDocumentos()) {
                    yield this.documentosComponent.fileUpload();
                }
                if (this.hasAvalista()) {
                    this.avalistaComponent.pushAvalista();
                }
                this.modalLoader.show('Respondendo o SOS...');
                let message;
                this.pushRespostaSos().pipe(finalize(() => this.handleEnvioSosFinished(message)))
                    .subscribe(() => (message = 'SOS Respondido com sucesso!'), () => (message = 'Ocorreu um erro ao responder o SOS, tente novamente.'));
                observableTimer(2000).subscribe(() => this.handleEnvioSosFinished('Sucesso'));
            }
            else {
                this.modalMessage
                    .show()
                    .modalClose.pipe(take(1))
                    .subscribe(() => this.router.navigateByUrl('/ficha'));
            }
        });
    }
    handleEnvioSosFinished(message) {
        this.modalLoader.hide();
        this.sharedService.reloadFicha();
    }
    validaEnvioSOS() {
        if (this.hasObservacao() && !this.observacao.validaEnvioObservacao()) {
            return false;
        }
        if (this.hasAvalista() && !this.avalistaComponent.validaEnvio()) {
            return false;
        }
        if (this.hasDocumentos() && !this.documentosComponent.validaEnvio()) {
            return false;
        }
        return true;
    }
    hasDocumentos() {
        return JSON.stringify(this.cardDireito.acoes).includes('GRAVAR_DOCS') && !this.isLojista();
    }
    hasObservacao() {
        return JSON.stringify(this.cardDireito.acoes).includes('GRAVAR_OBS');
    }
    hasAvalista() {
        return JSON.stringify(this.cardDireito.acoes).includes('INCLUIR_AVAL');
    }
    pushRespostaSos() {
        const body = { idProposta: this.idFicha };
        return this.fichaService.pushRespostaSos(body);
    }
    isLojista() {
        return this.loginStorage.usuario.tipoUsuarioTO.id === 7;
    }
    isAgente() {
        return this.loginStorage.usuario.tipoUsuarioTO.id === 8;
    }
    isRespondeSos() {
        const canAnswer = this.cardDireito.acoes.every((acao) => acao.respondeSos === 'S');
        return canAnswer && this.isLojista() || this.isAgente();
    }
}
